import { Injectable } from '@angular/core';
import {Http, ResponseContentType,Headers, RequestOptions} from '@angular/http';
import { environment } from '../../../../../environments/environment';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class IncidentServices {
    private apiUrl = `${environment.apiUrl}/api/v1`;
    private companyId = global['loginUser'].curCmpnId;

    constructor(private http: Http) {
        this.companyId = global['loginUser'].curCmpnId;
    };


    /**
     * incident
     * incident list 조회
     * Mothod : Get
     * API No : 2.01
     * /api/v1/{cmpnNo}/incident
     * **/
    getIncidentList(queryString) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/incident${queryString}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    downloadIncidentList(postData, queryString) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/incident/EXCEL${queryString}`;

        return this.http
            .post(url, JSON.stringify(postData),  {responseType: ResponseContentType.Blob, withCredentials: true })
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * incident
     * incident 상세 조회
     * Mothod : Get
     * API No : 2.04
     * /api/v1/{cmpnNo}/incident/{tcktNo}
     * **/
    getIncident(tcktNo: number, cmpnTcktType?: string) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/incident/${tcktNo}${cmpnTcktType !== undefined ? '/seq' : ''}`;
        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * incident
     * related alert조회
     * Mothod : Get
     * API No : 2.04
     * /api/v1/{cmpnNo}/incident/{tcktNo}/alert
     * **/
    getAutoRelatedAlert(tcktNo: number) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/incident/${tcktNo}/autoalert`;
        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * incident
     * Update Incident status
     * Mothod : Put
     * API No : 2.02
     * /api/v1/{cmpnNo}/incident/{status}
     * **/
    updateIncidentStatus(data: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/incident/status`;
        return this.http
            .put(url, JSON.stringify(data))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * incident
     * Reassign
     * Mothod : Put
     * API No : 2.07
     * /api/v1/{cmpnNo}/incident/{tckNo}/reassignee
     **/
    updateAssignee(putData: any, tckNo: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/incident/${tckNo}/reassignee`;
        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * incident
     * Update Description
     * Mothod : Put
     * API No : 2.09
     * /api/v1/{cmpnNo}/incident/{tckNo}/desc
     **/
    updateDescription(putData: any, tckNo: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/incident/${tckNo}/desc`;
        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * incident
     * Reassign
     * Mothod : Put
     * API No : 2.12
     * /api/v1/{cmpnNo}/incident/{tckNo}/comment
     **/
    createComment(putData: any, tckNo: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/incident/${tckNo}/comment`;
        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * incident
     * Reassign
     * Mothod : Put
     * API No : 2.05
     * /api/v1/{cmpnNo}/incident/{tckNo}/name
     **/
    updateName(putData: any, tckNo: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/incident/${tckNo}/name`;
        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * incident
     * Activity history list 조회
     * Mothod : Get
     * API No : 2.10
     * /api/v1/{cmpnNo}/incident/{tckNo}/history
     **/
    getActivityHistoryList(tckNo: any, queryString) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/incident/${tckNo}/history${queryString}`;
        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * incident
     * Escalation Policy Responders 조회
     * Mothod : Get
     * API No : 2.11
     * /api/v1/{cmpnNo}/incident/{tcktNo}/history/{tcktActvHistNo}/noti
     **/
    getEscalationPolicyResponders(tckNo: any, tcktActvHistNo: any, curCmpnId?: any) {
        let companyId;

        if (curCmpnId === undefined) {
            companyId = global['loginUser'].curCmpnId;
        } else {
            companyId = curCmpnId;
        }

        const url = `${this.apiUrl}/` + companyId + `/incident/${tckNo}/history/${tcktActvHistNo}/noti`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * incident
     * incident 등록
     * Mothod : Post
     * API No : 2.15
     * /api/v1/{cmpnNo}/incident
     **/
    // postInicident(postData: any) {
    //     const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/incident`;
    //     return this.http
    //         .post(url, JSON.stringify(postData))
    //         .toPromise()
    //         .then(res => res)
    //         .catch(this.handleError);
    // }

    postInicident(postData: any,file:File) {
        const options = new RequestOptions({withCredentials: true });
        options.headers = new Headers();
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/incident`;
        const formData: FormData = new FormData();
        formData.append('file', file);
        formData.append('incident', new Blob([JSON.stringify(postData)], { type: 'application/json' }));
        return this.http
            .post(url, formData, options)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }


    validateBulkNotificationFile(file:File) {
        const options = new RequestOptions({withCredentials: true });
        options.headers = new Headers();
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/incident/bulk/notification/file/validate`;
        const formData: FormData = new FormData();
        formData.append('file', file);
         return this.http
            .post(url, formData, options)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * incident
     * Merge
     * Mothod : Put
     * API No : 2.03
     * /api/v1/{cmpnNo}/incident/{tckNo}/merge
     **/
    mergeIncident(putData: any, tckNo: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/incident/${tckNo}/merge`;
        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * incident
     * Merge 또는 Related Incident 대상 조회
     * Mothod : Get
     * API No : 2.16
     * /api/v1/{cmpnNo}/incident/target?searchWord={searchWord}&page={page}&rows={rows}
     * **/
    getTrgtIncidentList(queryString) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/incident/target${queryString}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * incident
     * Related Incident 조회
     * Mothod : Get
     * API No : 2.17
     * /api/v1/{cmpnNo}/incident/{tcktNo}/rltdinct
     * **/
    getRelatedIncident(tcktNo) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/incident/${tcktNo}/rltdinct`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * incident
     * Relate Incident 수정
     * Mothod : Put
     * API No : 2.18
     * /api/v1/{cmpnNo}/incident/{tcktNo}/rltdinct
     **/
    putRelatedIncident(putData: any, tcktNo: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/incident/${tcktNo}/rltdinct`;
        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * incident
     * Modify Incident Urgency
     * Mothod : Put
     * API No : 2.21
     * /api/v1/{cmpnNo}/incident/{tcktNo}/urgency
     **/
    updateIncidentUrgency(putData: any, tcktNo: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/incident/${tcktNo}/urgency`;
        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * incident file
     * get incident File List
     * Method : Get
     * API No : 2.22
     * /api/v1/{cmpnNo}/incident/{tcktNo}/files
     * **/
    getFileList(tcktNo) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/incident/${tcktNo}/files`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * incident file
     * delete incident File
     * Method : delete
     * API No : 2.23
     * /api/v1/{cmpnNo}/incident/files/{fileNo}
     * **/
    deleteFile(fileNo) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/incident/files/${fileNo}`;
        return this.http
            .delete(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * incident file
     * download incident File
     * Method : get
     * API No : 2.24
     * /api/v1/{cmpnNo}/incident/files/{fileNo}
     * **/
    downloadFile(fileNo) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/incident/files/${fileNo}`;
        return this.http
            .get(url, {responseType: ResponseContentType.Blob})
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    downloadBulkNotificationFile() {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/incident/bulk/notification/file`;
        return this.http
            .get(url, {responseType: ResponseContentType.Blob})
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }
    


    /**
     * Notice Type Incident Template
     * Notice Type Incident Template List 조회
     * Mothod : get
     * API No : 1.0
     * /api/v1/{cmpnNo}/template
     **/
     getNoticeTemplateList() {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/template`;
        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

        /**
     * Notice Type Incident Template
     * Notice Type Incident Template 내용 조회
     * Mothod : get
     * API No : 1.0
     * /api/v1/{cmpnNo}/template/?
     **/
         getNoticeTemplate(notiTmpltNo) {
            const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/template/${notiTmpltNo}`;
            return this.http
                .get(url)
                .toPromise()
                .then(res => res)
                .catch(this.handleError);
        }

    private handleError(error: any) {
        //console.error('An error occurred', error);
        return Promise.resolve(error.message || error);
    }


    executeRunbook(runbook: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/runbook/execute`;
        return this.http
            .post(url, JSON.stringify(runbook))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    executeMultipleRunbooks(runbooks: any[]) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/runbook/execute-multiple`;
        return this.http
            .post(url, JSON.stringify(runbooks))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }
    
}



// WEBPACK FOOTER //
// ./src/app/shared/services/src/api/incident.services.ts